import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import StructuredData from './StructuredData';
import { SITE_URL } from '../seo/business';

const Breadcrumbs = ({ customTitle }) => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Don't show breadcrumbs on home page
  if (location.pathname === '/') {
    return null;
  }

  const formatBreadcrumb = (str) => {
    // Replace hyphens with spaces and capitalize each word
    return str
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  return (
    <>
    <StructuredData id="breadcrumbs-schema" type="BreadcrumbList" data={{
      '@context': 'https://schema.org', '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
        ...pathnames.map((part, index) => ({
          '@type': 'ListItem', position: index + 2,
          name: customTitle && index === pathnames.length - 1 ? customTitle : formatBreadcrumb(part),
          item: `${SITE_URL}/${pathnames.slice(0, index + 1).join('/')}`
        }))
      ]
    }} />
    <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2 text-sm">
        {/* Home */}
        <li>
          <Link 
            to="/" 
            className="flex items-center hover:text-orange-600 transition-colors"
            style={{ color: 'var(--text-light)' }}
          >
            <Home size={16} className="mr-1" />
            Home
          </Link>
        </li>

        {pathnames.map((value, index) => {
          const isLast = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;
          const displayName = customTitle && isLast ? customTitle : formatBreadcrumb(value);

          return (
            <li key={to} className="flex items-center">
              <ChevronRight size={16} className="mx-2" style={{ color: 'var(--text-light)' }} />
              {isLast ? (
                <span 
                  className="font-semibold" 
                  style={{ color: 'var(--dark-navy)' }}
                  aria-current="page"
                >
                  {displayName}
                </span>
              ) : (
                <Link 
                  to={to} 
                  className="hover:text-orange-600 transition-colors"
                  style={{ color: 'var(--text-light)' }}
                >
                  {displayName}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
    </>
  );
};

export default Breadcrumbs;
